import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import {
    callCardMetaDataAPI, callSetPayment
} from "actions/payment";
import { reduxForm, Field, getFormValues } from 'redux-form'
import { GoBack } from 'components/Common';
import { Col, NavLink, Form, FormGroup, Input, Button, Nav, NavItem } from 'reactstrap';

import GlobalLoaderModal from "components/FDModal/global-loader";

function RmsWidget(props) {
    const { t } = props;
    const [loading, setLoader] = useState(false);
    const [error, setError] = useState({
        errorMessage: "",
        status: false,
    });
    const [formUrl,setFormurl] = useState(null);
    const [reqData,setReqData] = useState(null);
    


    const handleChange = async () => {
        setLoader(true);
        try {
            const {
                data: { response }
            } = await callCardMetaDataAPI("RMS");
            if (response) {
                // console.log("MERCHANT",props.lstMerchWallet)
                const lstMerchWallet = props.lstMerchWallet;
                var data = {
                    "transactionDetails": {
                        "transactionType": "SALE",
                        "paymentMethod": "RMS"
                    },
                    "walletPaymentMethod": {
                        "firstPayWalletCode": lstMerchWallet[0].firstPayWalletCode,
                        "WalletName": lstMerchWallet[0].walletName
                    }
                };

               props.callSetPayment('RMS', data, props.txnKey, props.txnIv).then((resp) => {
                    const { errorCode, errorMessage, rmsRequestData,rmsWebUrl } = resp.payload.data;
                    if (errorCode) {
                        setError({
                            status: true,
                            errorCode,
                            errorMessage,
                        });
                        setLoader(false);
                    } else if (rmsWebUrl && rmsRequestData && rmsRequestData.trim() != "") {
                        setFormurl(rmsWebUrl);
                       //  console.log("RMSReqDATA",reqData);
                        const parsedData = JSON.parse(rmsRequestData);
                        setReqData(parsedData);
                        // window.location = resp.payload.data.grabPayWebUrl;
                        // setLoader({
                        //     loading:false,
                        //     buttonDisable:false
                        // });
                    }

                    // window.location = resp.payload.data.grabPayWebUrl;
                }) ;
            }
        } catch (e) {
            setLoader(false);
            setError({
                errorMessage: "Sorry could not proceed further",
                status: true
            })
        }


    }

    const redirectForm = async () => {
        console.log("FORMURL",formUrl);
    }

    useEffect(() => {
        redirectForm()
    },[formUrl])

    useEffect(() => {
        handleChange();
    }, [])


    const formFields = () => {
        setTimeout(() => {
            document.RMSFORM.submit();
        }, 1000);
       return Object.entries(reqData).map(([key,value]) => {
            return <input id={key} name={key} key={key} value={value} type="hidden"></input>

        })
    }

    return (<>
        {formUrl && reqData && 
           <FormGroup>
           <form action={formUrl} name='RMSFORM' method="POST">
              {
                  formFields()
              }
           </form>
         </FormGroup>
        }
    
        {loading && <GlobalLoaderModal></GlobalLoaderModal>}
        {error.status && <div className="go-back-site text-center">
            <p>{error.errorMessage}</p>
            <GoBack t={t} />
        </div>}
    </>)

}


const mapStateToProps = state => {
    // defaultSelectedPayment
    // console.log("STATE.FDData",state.fdData.defaultSelectedPayment)
    const { transactionDetails, txnKey, txnIv, SessionToken, termsStatus, paymentMethodType, integrationType, globalConfig,lstMerchWallet } = state.fdData;
    let returnProps = { transactionDetails, txnKey, txnIv,lstMerchWallet, SessionToken, termsStatus, paymentMethodType, integrationType, globalConfig };
    return { ...returnProps };
};

export default connect(mapStateToProps, { callSetPayment })(RmsWidget);